(function() {
  let isUpdating = false;
  
  function initStickyATC() {
    const stickyContainer = document.querySelector('.sticky-atc-container');
    if (!stickyContainer) return;
    
    // Get DOM elements
    const mainAddToCartBtn = document.querySelector('[data-main-product-add-to-cart]');
    const offset = parseInt(stickyContainer.dataset.offset) || 200;
    let isVisible = false;
    
    // Sticky bar elements
    const stickyQtyInput = document.querySelector('[data-sticky-qty-input]');
    const stickyMinusBtn = document.querySelector('[data-sticky-qty="minus"]');
    const stickyPlusBtn = document.querySelector('[data-sticky-qty="plus"]');
    const stickyAtcBtn = document.querySelector('[data-sticky-atc-btn]');
    const stickySelects = document.querySelectorAll('[data-sticky-option-index]');
    
    // Main product elements
    const mainQtyInput = document.querySelector('.product-quantity .qty-selector, input[name="quantity"]');
    const mainForm = document.querySelector('#add-to-cart-form, .product-form form');
    
    // Function to safely update quantity without double triggers
    function updateQuantity(source, value) {
      if (isUpdating) return;
      isUpdating = true;
      
      value = parseInt(value);
      if (isNaN(value) || value < 1) value = 1;
      if (value > 999) value = 999;
      
      // Update sticky input (always update it when triggered from anywhere)
      if (stickyQtyInput) {
        stickyQtyInput.value = value;
      }
      
      // Update main input
      if (mainQtyInput) {
        mainQtyInput.value = value;
        // Trigger change event for main quantity
        mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      setTimeout(() => { isUpdating = false; }, 100);
    }
    
    // Sticky quantity controls
    if (stickyMinusBtn) {
      stickyMinusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (stickyQtyInput) {
          let currentVal = parseInt(stickyQtyInput.value);
          if (isNaN(currentVal)) currentVal = 1;
          let newVal = currentVal - 1;
          if (newVal >= 1) {
            updateQuantity('sticky', newVal);
          }
        }
      });
    }
    
    if (stickyPlusBtn) {
      stickyPlusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (stickyQtyInput) {
          let currentVal = parseInt(stickyQtyInput.value);
          if (isNaN(currentVal)) currentVal = 1;
          let newVal = currentVal + 1;
          if (newVal <= 999) {
            updateQuantity('sticky', newVal);
          }
        }
      });
    }
    
    if (stickyQtyInput) {
      stickyQtyInput.addEventListener('change', function(e) {
        e.preventDefault();
        updateQuantity('sticky', this.value);
      });
    }
    
    // Main quantity sync
    if (mainQtyInput) {
      const mainQtyObserver = function() {
        if (!isUpdating && stickyQtyInput) {
          let val = parseInt(mainQtyInput.value);
          if (!isNaN(val)) {
            let stickyVal = parseInt(stickyQtyInput.value);
            if (val !== stickyVal) {
              updateQuantity('main', val);
            }
          }
        }
      };
      
      mainQtyInput.addEventListener('change', mainQtyObserver);
      
      // Watch for clicks on main plus/minus buttons
      const mainMinusBtn = document.querySelector('.product-quantity .qty-minus');
      const mainPlusBtn = document.querySelector('.product-quantity .qty-plus');
      
      if (mainMinusBtn) {
        mainMinusBtn.addEventListener('click', () => setTimeout(mainQtyObserver, 50));
      }
      if (mainPlusBtn) {
        mainPlusBtn.addEventListener('click', () => setTimeout(mainQtyObserver, 50));
      }
    }
    
    // Variant sync - from sticky to main
    stickySelects.forEach((select) => {
      select.addEventListener('change', function() {
        if (isUpdating) return;
        
        const optionIndex = this.getAttribute('data-sticky-option-index');
        const selectedValue = this.value;
        
        // Find and trigger main variant radio button
        const mainRadio = document.querySelector(`.product-variant input[value="${selectedValue}"]`);
        if (mainRadio && mainRadio.type === 'radio') {
          mainRadio.checked = true;
          mainRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
    
    // Variant sync - from main to sticky
    const mainVariantsContainer = document.querySelector('[data-main-product-variants]');
    if (mainVariantsContainer) {
      const variantObserver = new MutationObserver(function() {
        if (isUpdating) return;
        
        const selectedValues = [];
        document.querySelectorAll('.product-variant input:checked').forEach(input => {
          if (input.value) selectedValues.push(input.value);
        });
        
        stickySelects.forEach((select, index) => {
          if (selectedValues[index] && select.value !== selectedValues[index]) {
            isUpdating = true;
            select.value = selectedValues[index];
            setTimeout(() => { isUpdating = false; }, 100);
          }
        });
        
        // Update price
        const mainPrice = document.querySelector('[data-js-product-price-original]');
        const mainCompare = document.querySelector('[data-js-product-price-compare] span');
        const stickyPrice = document.querySelector('.sticky-price-current');
        const stickyCompare = document.querySelector('.sticky-price-compare');
        
        if (mainPrice && stickyPrice) {
          stickyPrice.innerHTML = mainPrice.innerHTML;
        }
        if (mainCompare && stickyCompare) {
          if (mainCompare.innerHTML.trim()) {
            stickyCompare.style.display = 'inline';
            stickyCompare.innerHTML = mainCompare.innerHTML;
          } else {
            stickyCompare.style.display = 'none';
          }
        }
        
        // Update variant ID on sticky button
        const variantIdInput = document.querySelector('input[name="id"]');
        if (variantIdInput && stickyAtcBtn) {
          stickyAtcBtn.setAttribute('data-variant-id', variantIdInput.value);
        }
        
        // Update button disabled state
        if (mainAddToCartBtn && stickyAtcBtn) {
          stickyAtcBtn.disabled = mainAddToCartBtn.classList.contains('disabled');
        }
      });
      
      variantObserver.observe(mainVariantsContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['checked']
      });
    }
    
    // Sticky ATC button - TRIGGER MAIN BUTTON (NO DUPLICATION)
    if (stickyAtcBtn && mainAddToCartBtn) {
      stickyAtcBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Simply click the main add to cart button
        // The quantity is already synced, so it will use the correct quantity
        if (!mainAddToCartBtn.disabled) {
          mainAddToCartBtn.click();
        }
      });
    }
    
    // Visibility logic
    function checkVisibility() {
      if (!mainAddToCartBtn) {
        if (window.scrollY > offset && !isVisible) {
          showSticky();
        } else if (window.scrollY <= offset && isVisible) {
          hideSticky();
        }
        return;
      }
      
      const rect = mainAddToCartBtn.getBoundingClientRect();
      const isMainVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
      
      if (!isMainVisible && !isVisible) {
        showSticky();
      } else if (isMainVisible && isVisible) {
        hideSticky();
      }
    }
    
    function showSticky() {
      stickyContainer.style.display = 'block';
      setTimeout(() => stickyContainer.classList.add('visible'), 10);
      isVisible = true;
      
      // Sync initial values
      setTimeout(() => {
        if (mainQtyInput && stickyQtyInput) {
          let mainVal = parseInt(mainQtyInput.value);
          if (!isNaN(mainVal)) {
            stickyQtyInput.value = mainVal;
          }
        }
        // Trigger variant sync
        const variantIdInput = document.querySelector('input[name="id"]');
        if (variantIdInput && stickyAtcBtn) {
          stickyAtcBtn.setAttribute('data-variant-id', variantIdInput.value);
        }
        if (mainAddToCartBtn && stickyAtcBtn) {
          stickyAtcBtn.disabled = mainAddToCartBtn.classList.contains('disabled');
        }
      }, 100);
    }
    
    function hideSticky() {
      stickyContainer.classList.remove('visible');
      setTimeout(() => {
        if (!stickyContainer.classList.contains('visible')) {
          stickyContainer.style.display = 'none';
        }
      }, 300);
      isVisible = false;
    }
    
    window.addEventListener('scroll', checkVisibility);
    window.addEventListener('resize', checkVisibility);
    checkVisibility();
    
    // Initial sync
    setTimeout(() => {
      if (mainQtyInput && stickyQtyInput) {
        let mainVal = parseInt(mainQtyInput.value);
        if (!isNaN(mainVal)) {
          stickyQtyInput.value = mainVal;
        }
      }
    }, 500);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATC);
  } else {
    initStickyATC();
  }
})();